/*
 * @Author: Yue Hu(yuhu@nvidia.com)
 * @Date: 2024-11-25 22:30:59
 * @LastEditors: Yue Hu(yuhu@nvidia.com)
 * @LastEditTime: 2024-11-25 22:51:08
 * @FilePath: /mooctest.com/src/config/config.js
 */
export const TargetType = {
  DEVELOPER: 10, // 开发者
  WEB: 8, // Web
  V2X: 16, // 车联网
  HARMONY: 18, // 鸿蒙
};
export const answerWayOption = {
  // 开发者
  DEVELOPER: 1,
  WEB_FUNCTION_ECLIPSE: 3,
  WEB_FUNCTION_ONLINE: 17,
};

export const SubjectIdMap = {
  WEB_PERFORMANCE: 57,
  WEB_FUNCTION: 64,
  V2X: 62,
  DEVELOPER: 60,
  HARMONY: 63,
};

export const TaskState = {
  NoStart: 0,
  WIP: 1,
  Marking: 2,
  End: 3,
};

export const submitFileConfig = {
  DEV: [
    {
      name: "dev_java",
      label: "answerFile",
      size: 1,
      acceptType: [".java"],
    },
  ],
  V2X: [
    {
      name: "v2x",
      label: "answerFile",
      size: 10,
      acceptType: [".zip", ".xlsx", ".xls"],
    },
  ],
  WEB: [
    {
      name: "web_testcase",
      label: "submitDocForWEB",
      size: 1,
      acceptType: [".xls", ".xlsx"],
    },
    {
      name: "web_code",
      label: "submitCodeForWEB",
      size: 1,
      acceptType: [".java"],
    },
    {
      name: "web_screenshot",
      label: "submitPackageForWEB",
      size: 50,
      acceptType: [".zip"],
    },
  ],
  HARMONY: [
    {
      name: "harmony",
      label: "answerFile",
      size: 50,
      acceptType: [".zip"],
    },
  ],
};
